import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import type { AuthRequest, SignupVerifyPayload } from '@sb/shared/auth/data-access';
import { AuthService } from '@sb/shared/auth/data-access';

import { authState } from '../reducers/auth/auth-service.selectors';
import { AuthService as LegacyAuthService } from '../reducers/auth/auth.service';
import type { AppState } from '../reducers/interfaces';

/**
 * Bridge that connects the abstract `AuthService` (from the library) to the
 * existing NgRx-based `AuthService` in the main app.
 */
@Injectable()
export class AuthServiceBridge implements AuthService {
  #store = inject<Store<AppState>>(Store);
  #legacy = inject(LegacyAuthService);

  authLoading = this.#store.selectSignal((state: AppState) => state.auth.loading);
  authState = this.#store.selectSignal(authState);
  redirectUrl = this.#legacy.redirectUrl;

  login(credentials: AuthRequest) {
    return this.#legacy.login(credentials);
  }

  load() {
    return this.#legacy.load();
  }

  forgotPassword(payload: { email: string }) {
    return this.#legacy.forgotPassword(payload);
  }

  resetPassword(payload: Record<string, unknown>) {
    return this.#legacy.resetPassword(payload);
  }

  verifySignUp(payload: SignupVerifyPayload) {
    return this.#legacy.verifySignUp(payload);
  }

  async logout() {
    await this.#legacy.logout();
  }
}
